import { useLocalStorage } from "@src/appV2/lib/utils";
import {
  INTERESTED_WORK_TYPE_STORAGE_KEY,
  WorkTypeOption,
} from "@src/appV2/redesign/Onboarding/components/InterestedWorkType";

export function useSelectedWorkType() {
  const [selectedOption, setSelectedOption] = useLocalStorage<WorkTypeOption | undefined>(
    INTERESTED_WORK_TYPE_STORAGE_KEY,
    undefined
  );

  return {
    selectedWorkType: selectedOption,
    setSelectedWorkType: setSelectedOption,
    isPermanentPlacementsOnboarding: selectedOption === WorkTypeOption.PERMANENT_PLACEMENTS,
    isFlexOnboarding: selectedOption === WorkTypeOption.FLEX || selectedOption === undefined,
    isFlexAndPermanentPlacementsOnboarding: selectedOption === WorkTypeOption.PERMANENT_AND_FLEX,
  };
}
